import { r4Client, r4Error } from '@/services'

const OpsCodesApi = {

  async searchOpsCodes (dealerId, searchTerm) {
    try {
      const resp = await r4Client().get('/api/v1/query_engine/ops_codes', { params: { dealer_id: dealerId, term: searchTerm } })
      return resp.data
    } catch (error) {
      // wrap it in an r4 error
      throw r4Error(error)
    }
  },
  async searchExtendedOpsCodes (searchTerm) {
    try {
      const resp = await r4Client().get('/api/v1/query_engine/ops_codes', { params: { term: searchTerm, extended: true } })
      return resp.data
    } catch (error) {
      // wrap it in an r4 error
      throw r4Error(error)
    }
  }
}

export default OpsCodesApi
